<template>

    <div class="service" :id="data.id" :data-speed="data.speed"
        v-on:mouseover="mouseOver"
        v-on:mouseleave="mouseLeave"
        v-on:click="onClick(data.id)"
        ref="parent">

        <div class="bg" ref="bg" :style="styleObject.background"></div>
        <div class="overlay" ref="overlay"></div>

        <h1 class="title" ref="title" :style="styleObject.title">
            {{ data.title }}
        </h1>

        <div class="arrow" ref="arrow">
            <div class="rect" ref="rect"></div>
            <div class="corner">
                <div class="right border" ref="borderRight"></div>
                <div class="bottom border" ref="borderBottom"></div>
            </div>
        </div>

        <div class="top border" ref="borderTop"></div>
        <div class="left border" ref="borderLeft"></div>
    </div>
</template>

<script>
import Animation from "./Animation.js";
import Service from "./Service.js";

export default {
  props: ["data", "index"],
  data() {
    return {
      Animation: new Animation(this.$refs, this.data),
      Service: new Service(this.data, this.index)
    };
  },
  methods: {
    mouseOver: function() {
      this.Animation.onHover();
    },
    mouseLeave: function() {
      this.Animation.reverse();
    },
    onClick: function(serviceId) {
      this.$emit("open", serviceId);
    },
    windowResize: function() {
      // this.Service.windowResize();
    }
  },
  created() {
    // window.addEventListener("resize", this.windowResize);
  },
  mounted() {
    this.Animation.prepare(this.$refs);
  },

  computed: {
    styleObject: function() {
      return this.Service.getStyleObject(this.data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Services/Service.vue